import React from "react";

const Navigation = () => {
  return (
    <nav class="navbar navbar-light bg-light">
      <div class="container-fluid">
        <a class="navbar-brand" href="/">
          React Redux Shop
        </a>
      </div>
    </nav>
  );
};

export default Navigation;
